import {Pipe, PipeTransform, inject} from '@angular/core';
import {I18nService} from "../../services/i18n/i18n.service";

@Pipe({
  name: 'accDate',
  standalone: true
})
export class AccDate implements PipeTransform {
  private readonly i18n = inject(I18nService);

  transform(value: Date | undefined): string | undefined | null {
    if (value !== undefined) {
      return this.i18n.getDateParser().fromDate(value);
    }
    return null;
  }
}
